/* eslint-disable no-param-reassign */

import { Editor } from 'slate';

import { HIGHLIGHT_MARK } from 'src/data/markedText';

export function withMarking(editor) {
  const { insertBreak, insertText, insertData } = editor;

  // Check if 'mark' present, and add it if not
  const ensureMarkPresent = () => {
    const marks = Editor.marks(editor);
    if (marks && marks.mark !== HIGHLIGHT_MARK.user) {
      // HINT: we had to replace simple 'addMark' call with direct manipulation, see: https://github.com/ianstormtaylor/slate/issues/3708
      editor.marks = {
        ...marks,
        mark: HIGHLIGHT_MARK.user,
      };
    }
  };

  // Convert 'paste' data, marking all of it with 'mark'
  const markInsertData = (originalData) => {
    const plainText = originalData.getData('text/plain');

    const fragments = plainText.split('\n').map((p) => ({
      type: 'paragraph',
      children: [{ text: p, mark: HIGHLIGHT_MARK.user }],
    }));
    const string = JSON.stringify(fragments);
    const encoded = window.btoa(encodeURIComponent(string));

    let data;

    try {
      data = new DataTransfer();
    } catch (e) {
      data = originalData;
    }

    try {
      data.setData('text/plain', plainText);
      data.setData('application/x-slate-fragment', encoded);
    } catch (e) {
      // nothing
    }

    return data;
  };

  editor.insertBreak = () => {
    ensureMarkPresent();

    insertBreak();
  };

  editor.insertText = (text) => {
    ensureMarkPresent();

    insertText(text);
  };

  editor.insertData = (originalData) => {
    ensureMarkPresent();

    const data = markInsertData(originalData);
    insertData(data);
  };

  return editor;
}
